import * as Sentry from '@sentry/browser';
import { pauseForSpecs } from '~/javascripts/utils/testing';

export default function (form) {
  const submitBtn = $(form).find("[type='submit']");
  const recaptchaTokenInput = () => $(form).find('.recaptcha_token');

  document.addEventListener('recaptchaSuccess', (event) => {
    if (submitBtn.attr('disabled') === 'disabled') {
      recaptchaTokenInput().val(event.detail.token);
      $(form).submit();
    }
  });

  $(form).on('ajax:complete', (xhr, response) => {
    if (response.status == 418) {
      window.recaptcha.instances[$(form).attr('id')].toggle();
    } else if (response.status == 200) {
      pauseForSpecs(() => {
        const redirectUrl = response.responseJSON['redirect_to'];
        if (redirectUrl) {
          window.location = redirectUrl;
          const splitUrl = redirectUrl.split('#');
          if (
            splitUrl[1] !== undefined &&
            window.location.href.includes(splitUrl[0])
          ) {
            window.location.reload(true);
          }
        }
      });
    } else if (response.status == 422) {
      recaptchaTokenInput().val('');
      $(form)
        .find('input')
        .each((_index, input) => {
          $(input).parsley().reset();
        });
      if (response.responseText.length > 0 && response.responseJSON) {
        $.each(response.responseJSON.errors, (fieldName, validationError) => {
          const input = $(form).find(`[name='${fieldName}']`);
          input
            .parsley()
            .addError('server_side_error', { message: validationError });
        });
      } else {
        $(form).find('input:first').parsley().addError('server_side_error', {
          message:
            'Sorry, Something went wrong. Please reload the page and try again.',
        });
      }
      pauseForSpecs(() => {
        submitBtn.removeAttr('disabled');
        submitBtn.find('.cw-icon-loop').remove();
      });
    } else {
      Sentry.withScope((scope) => {
        scope.setExtra('xhr', xhr);
        scope.setExtra('response', response);
        Sentry.captureMessage(
          'Unhandled server error in RateLimitedRecaptchaForm - JAAZZZZZZDDEEEEEEPPPP!?!?!?!?!!!!!'
        );
      });
    }
  });

  submitBtn.on('click', (event) => {
    event.preventDefault();

    if (!form.parsley().validate()) {
      return false;
    }

    $(form).submit();
    submitBtn.attr('disabled', 'disabled');
    submitBtn.prepend('<i class="cw-icon-loop cw-icon-spin mr-1"></i>');
  });
}
